<script setup lang="ts">
import { type Media } from '@models/media.ts';
import MediaImage from '@components/MediaImage.vue';

defineProps<{
  title: string,
  media: Media
}>();
</script>

<template>
  <div class="real-estate-summary">
    <MediaImage
      class="real-estate-summary__picture"
      img-class="real-estate-summary__img"
      :uuid="media.uuid"
      :alt="media.description"
      :width="72"
      :height="72"
    />

    <div class="real-estate-summary__content">
      <h2 class="real-estate-summary__title">
        {{ title }}
      </h2>

      <div class="content">
        <slot />
      </div>
    </div>
  </div>
</template>
